(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
(function() {
  var range = document.getElementById('dh-ba-range');
  var after = document.getElementById('dh-ba-after');
  var divider = document.getElementById('dh-ba-divider');
  if (!range || !after || !divider) return;
  function update(val) {
    var pct = val + '%';
    after.style.clipPath = 'inset(0 ' + (100 - val) + '% 0 0)';
    divider.style.left = pct;
  }
  update(range.value);
  range.addEventListener('input', function() { update(this.value); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function() {
  const burger = document.querySelector('.dh-nav__burger');
  const mobileNav = document.getElementById('dh-mobile-nav');
  if (!burger || !mobileNav) return;
  burger.addEventListener('click', function() {
    const open = burger.getAttribute('aria-expanded') === 'true';
    burger.setAttribute('aria-expanded', String(!open));
    mobileNav.hidden = open;
  });
  mobileNav.querySelectorAll('a').forEach(function(a) {
    a.addEventListener('click', function() {
      burger.setAttribute('aria-expanded', 'false');
      mobileNav.hidden = true;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients"] && !Shopify.designMode) return;
  try {
    
(function() {
  var tabs = document.querySelectorAll('.dh-ing__tab');
  var panels = document.querySelectorAll('.dh-ing__panel');
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var idx = parseInt(tab.getAttribute('data-index'), 10);
      tabs.forEach(function(t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      panels.forEach(function(p) {
        p.classList.remove('is-active');
        p.hidden = true;
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      if (panels[idx]) {
        panels[idx].classList.add('is-active');
        panels[idx].hidden = false;
      }
    });
  });
  var inciBtn = document.querySelector('.dh-ing__inci-toggle');
  var inciList = document.getElementById('dh-inci-list');
  if (inciBtn && inciList) {
    inciBtn.addEventListener('click', function() {
      var open = inciBtn.getAttribute('aria-expanded') === 'true';
      inciBtn.setAttribute('aria-expanded', String(!open));
      inciList.hidden = open;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  var planBtns = document.querySelectorAll('.dh-ph__plan-btn');
  planBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      planBtns.forEach(function(b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });
  var qty = 1;
  var qtyEl = document.getElementById('dh-ph-qty');
  var formQty = document.getElementById('dh-form-qty');
  var minus = document.getElementById('dh-ph-minus');
  var plus = document.getElementById('dh-ph-plus');
  function updateQty() {
    if (qtyEl) qtyEl.textContent = qty;
    if (formQty) formQty.value = qty;
  }
  if (minus) minus.addEventListener('click', function() { if (qty > 1) { qty--; updateQty(); } });
  if (plus) plus.addEventListener('click', function() { qty++; updateQty(); });
  var form = document.getElementById('dh-add-form');
  var atcBtn = document.getElementById('dh-atc-btn');
  if (form && atcBtn) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var variantId = document.getElementById('dh-variant-id');
      if (!variantId) return;
      atcBtn.disabled = true;
      var origText = atcBtn.textContent;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId.value, 10), quantity: qty })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        atcBtn.textContent = '✓ Hinzugefügt';
        setTimeout(function() { atcBtn.textContent = origText; atcBtn.disabled = false; }, 2500);
      })
      .catch(function() { atcBtn.disabled = false; });
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
